import { render } from "./SpinnerLoader.vue?vue&type=template&id=d5364b82&scoped=true"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js"

import "./SpinnerLoader.vue?vue&type=style&index=0&id=d5364b82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5364b82"]])

export default __exports__